exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_option_eUispnb2RFANaPjd7GQ-z {\n  width: 100%;\n  height: 30px;\n}\n\n.IA_icon_2KmcC0AEvJ-ZbhkD3DQajS {\n  float: left;\n}\n\n.IA_label_34So0yuVVD5HW0gjv9VHmF {\n  float: left;\n  margin-left: 10px;\n  line-height: 30px;\n}", ""]);

// Exports
exports.locals = {
	"IA_option": "IA_option_eUispnb2RFANaPjd7GQ-z",
	"IA_icon": "IA_icon_2KmcC0AEvJ-ZbhkD3DQajS",
	"IA_label": "IA_label_34So0yuVVD5HW0gjv9VHmF"
};